// prettier-ignore
// resolve correct environment domain
const getDomain = () =>
  (/localhost:8446|8586|8082/.test(window.location.href)
    ? `${window.location.protocol}//localhost:8446`
    : 'https://secure.checkout.visa.com');

export default getDomain;
